<template>
    <div class="step sqft">
        <AdvTitle>{{ $t("common:signLog.adv.sqftTitle") }}</AdvTitle>
        <div class="adv-btn-group sqft-choose">
            <AdvBtn
                v-for="item in list"
                :key="item"
                type="reverse"
                @click="handleNext(item)"
            >{{ item }}</AdvBtn
            >
        </div>
        <div class="adv-progress-wrap" v-if="!platform.isMobile">
            <AdvProgress :value="progress()"></AdvProgress>
        </div>
    </div>
</template>
<script>
import AdvBtn from './components/btn.vue';
import AdvProgress from './components/progress.vue';
import AdvTitle from './components/title.vue';
export default {
    inject: ['progress', 'next'],
    data: function() {
        return {
            list: [
                '1000~2000sqft',
                '2000~3000sqft',
                '3000~4000sqft',
                '4000+sqft'
            ]
        };
    },
    methods: {
        handleNext(item) {
            this.next({ size: item }, 'questionAnswer');
        }
    },
    components: {
        AdvBtn,
        AdvProgress,
        AdvTitle
    }
};
</script>
<style lang="scss"></style>
